// @flow
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import { SnackbarProvider } from 'notistack';
import { usePingSubscription } from '@coverright/data-access/enrollment';
import { AgentCallAgendaProvider } from '../shared';
import { RequiredActionSnack, RequiredActionsProvider } from '../features';

export function Providers({ children }: PropsWithChildren) {
  usePingSubscription()
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        preventDuplicate
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        Components={{
          requiredAction: RequiredActionSnack
        }}
        autoHideDuration={6000}
        maxSnack={10}
      >
        <AgentCallAgendaProvider>
          <RequiredActionsProvider>
            {children}
          </RequiredActionsProvider>
        </AgentCallAgendaProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}
